const FAQS = [
  {
    q: '花生影院的电影资源是免费的吗？需要注册吗？',
    a: '花生影院所有电影资源均支持免费在线观看，无需注册即可直接播放。我们致力于为影迷提供零门槛的观影体验，打开网站就能开始看电影。如果你希望使用收藏夹、观看历史等个性化功能，可以选择免费注册账号，云端同步你的观影记录。',
  },
  {
    q: '观看电影需要安装什么播放器或插件吗？',
    a: '完全不需要。花生影院采用HTML5播放技术，支持主流浏览器直接播放，包括Chrome、Safari、Edge和Firefox。无论你用电脑、平板还是手机，打开网页就能看，不需要下载安装任何额外软件或浏览器插件。',
  },
  {
    q: '为什么花生影院能做到高清不缓冲？画质怎么样？',
    a: '我们自建了多线CDN智能分发网络，在全国范围内部署了加速节点。系统会根据你的网络环境自动选择最优线路，确保高清片源流畅加载。平台大部分影片提供1080P高清画质，部分热门新片支持4K超高清，只要你的网络带宽充足就能享受极致画质。',
  },
  {
    q: '电影排行榜是怎么计算的？多久更新一次？',
    a: '花生影院电影排行榜综合了三个维度的数据：影片播放量、用户评分以及讨论区活跃度。系统每小时自动刷新排名数据，确保榜单始终反映最新的用户选择趋势。同时我们的人工编辑团队也会定期甄选优质影片进入推荐位，让好电影不被埋没。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            关于花生影院的常见疑问，这里都有答案
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3 md:space-y-4">
          {FAQS.map((faq, i) => (
            <div
              key={i}
              className="rounded-xl bg-background-100 border border-secondary-100/60 overflow-hidden"
            >
              <div className="p-5 md:p-6">
                <div className="flex items-start gap-3">
                  <div className="w-7 h-7 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0 mt-0.5">
                    <span className="text-sm font-medium">Q</span>
                  </div>
                  <div>
                    <h3 className="text-sm md:text-base font-medium text-foreground-900 mb-2">
                      {faq.q}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {faq.a}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}